<template>
  <div>
    <v-container>
      <v-row>
        <v-col class="pa-5">
          <h1 class="text-center mb-4">Pegas con Sentido</h1>
          <p class="text-center">Ikigai WEB</p>
          <p class="text-center">Version: {{ tag }}</p>
          <p class="text-center">Branch: {{ branch }}</p>
          <p class="text-center">Hash: {{ hash }}</p>
          <p class="text-center">Fecha: {{ date }}</p>
          <p class="text-center">Stage: {{ stage }}</p>
          <p class="text-center">API: {{ apiUrl }}</p>
        </v-col>
      </v-row>
    </v-container>

    <Footer />
  </div>
</template>

<script>
import { meta } from "@/libs/mixins";

export default {
    name: "About",

    mixins: [meta],

    metaInfo() {
        return this.getMetaInfo({
            title: "Sobre este sitio",
        });
    },

    data() {
        return {
            tag: process.env.VUE_APP_GIT_TAG,
            hash: process.env.VUE_APP_GIT_HASH,
            branch: process.env.VUE_APP_GIT_BRANCH,
            commitDate: new Date(process.env.VUE_APP_GIT_DATE),
            stage: process.env.NODE_ENV,
            apiUrl: process.env.VUE_APP_ROOT_API
        };
    },

    computed: {
        date() {
            //return this.commitDate.toISOString().slice(0, 19).replace("T", " ");
            return "no date";
        }
    }
};
</script>
